import { QueryClient } from "@tanstack/react-query";

import { OurUseQueryOptions } from "@nens/react-query-utils";

/**
 * Tries to find a single item by uuid in any cached list query matching `listQueryKey`.
 * All list queries return `{ results: T[] }` (either paginated responses or fetchAllPages results).
 * If the item is not found in cache, falls back to fetching via `singleQuery`.
 */
export const findInListQuery = async <T extends { uuid?: string }>(
  queryClient: QueryClient,
  listQueryKey: readonly unknown[],
  uuid: string,
  singleQuery: OurUseQueryOptions<T>
): Promise<T> => {
  const queries = queryClient.getQueryCache().findAll({ queryKey: listQueryKey });

  for (const query of queries) {
    const data = query.state.data as { results?: T[] } | undefined;
    if (data?.results) {
      const item = data.results.find((it) => it.uuid === uuid);
      if (item) return item;
    }
  }
  return queryClient.ensureQueryData({
    queryKey: singleQuery.queryKey,
    queryFn: singleQuery.queryFn,
  });
};
